import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { caseStudies } from '../data/mockData';
import { Button } from './ui/button';

const CaseStudiesSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % caseStudies.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + caseStudies.length) % caseStudies.length);
  };

  const currentCase = caseStudies[currentIndex];

  return (
    <section className="relative bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 py-20 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-10 left-10 w-64 h-64 bg-orange-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <span className="text-orange-400 font-medium tracking-widest uppercase text-sm">
              Case Studies
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Uncover our legacy of triumphs<br />and insightful journeys,
          </h2>
          <Link to="/insights">
            <Button
              className="mt-6 bg-transparent border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-8 py-3 text-base font-medium rounded-full transition-all duration-300"
            >
              Know more
            </Button>
          </Link>
        </div>

        {/* Case Study Card */}
        <div className="relative">
          <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-3xl p-8 md:p-12 max-w-4xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8">
              {/* Challenges */}
              <div className="text-center md:text-left">
                <h3 className="text-orange-400 text-lg font-semibold mb-4">Challenges</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {currentCase.challenges}
                </p>
              </div>

              {/* Benefits */}
              <div className="text-center md:text-left">
                <h3 className="text-green-400 text-lg font-semibold mb-4">Benefits</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {currentCase.benefits}
                </p>
              </div>

              {/* Solution */}
              <div className="text-center md:text-left">
                <h3 className="text-blue-400 text-lg font-semibold mb-4">Solution</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  {currentCase.solution}
                </p>
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-10 space-x-2">
              {caseStudies.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-orange-500 w-8'
                      : 'bg-gray-600 hover:bg-gray-500'
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-12 h-12 bg-slate-700/50 hover:bg-slate-600 rounded-full flex items-center justify-center text-white transition-all"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-12 h-12 bg-slate-700/50 hover:bg-slate-600 rounded-full flex items-center justify-center text-white transition-all"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
